import { LocalDate } from '../../../utilities/local-date';

export function calculateStaffingCalendarYearOptions(): { id: string; value: string }[] {
  const options: { id: string; value: string }[] = [];
  const startYear = 2018;
  const thisYear = LocalDate.now().year();
  const yearsFromNow = 10;
  const yearsCount = thisYear - startYear + yearsFromNow;
  let optionYear = startYear;
  for (let y = 0; y < yearsCount; y++) {
    options.push({ id: optionYear.toString(), value: optionYear.toString() });
    optionYear += 1;
  }
  return options;
}
